import { OptinCode, IUserOptin, IOptinOptionsForCode } from "@foodi/core";
import _ from "lodash";

export type IAllOptins = {
  [K in OptinCode]: {
    enabled: boolean;
    options?: IOptinOptionsForCode<K>;
  };
};

export class OptinsViewModel {
  static initOptins(
    allOptins: IAllOptins,
    selectedOptins: IUserOptin[]
  ): IAllOptins {
    const _allOptins = _.cloneDeep(allOptins);
    selectedOptins.forEach((userOptin) => {
      const code = userOptin.optin.code;
      (_allOptins[code] as any) = {
        enabled: true,
        options: userOptin.optinOptions
          ? _.omit(userOptin.optinOptions, "__typename")
          : undefined,
      };
    });

    return _allOptins;
  }

  static getSelectedOptins(
    allOptins: IAllOptins
  ): {
    [K in OptinCode]: {
      code: K;
      options?: IOptinOptionsForCode<K>;
    };
  }[OptinCode][] {
    return Object.entries<any>(allOptins)
      .filter(([_, value]) => value.enabled)
      .map(([code, value]: any) => ({ code, options: value.options }))
      .flat();
  }

  static userConsentedToOptin(
    optins: IUserOptin[],
    desiredOptinCode: OptinCode
  ): boolean {
    return optins.some((o) => o.optin.code === desiredOptinCode);
  }

  static getOptinOptions = <T extends OptinCode>(
    code: T,
    optins: IUserOptin[]
  ): IOptinOptionsForCode<T> | undefined => {
    const optin = optins.find((o) => o.optin.code === code);
    return optin?.optinOptions as IOptinOptionsForCode<T> | undefined;
  };
}
